import { AddPrimitivesCommand, BasicControl, CURSOR_TYPE, dymode, DYMODE_MODE, LineT, Listeners, MOUSE, Point, Polygon, TnEngineContext, TnEngineExtraContext, ViewEditor } from "pytha";
import { STRUCTURE_CTRL_TYPE } from "../enums/structure-control-type";
import { Vector3 } from "three";
import { STRUCTURE_SIGNAL } from "../enums/structure-signal";
import { SFloorT } from "../models/SFloorT";

export class AddSFloorControl extends BasicControl {

    id = STRUCTURE_CTRL_TYPE.ADD_SFLOOR;

    needInit: boolean;

    capturePoint: Vector3;
    point_down: Point = new Point();
    point_move: Point = new Point();

    step: number = 0;

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    helpLines: LineT[] = [];
    options = {
        2: [
            { name: '闭合', key: 'C' },
        ],
    }

    //是否可以生成墙
    couldGenerateWall: boolean = true;
    //标记是否是直接退出的
    exitSimply: boolean = true;
    thickness: number = 0;
    //板的z轴偏移
    ez: number = 0;
    componentData: any;
    private boundInitControl: Function;
    layerUuid: string = '';

    constructor(editor: ViewEditor, listeners: Listeners) {
        super();
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();

        this.boundInitControl = this.initControl.bind(this);
        this.listeners.getSignal(STRUCTURE_SIGNAL.initSFloorControl).add(this.boundInitControl);
        this.listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.add(this.onKeyMouseConfirm);
        this.editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onPointCapture.add(this.onPointCapture);

        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
        this.editor.clampControl.enabled = false;
        this.editor.clampControl.hidden = true;
        // 派发置空选择集的信号
        this.listeners.signals.emptySelectedEntities.dispatch();

        console.log('AddSFloorControl added');
    }

    dispose(): void {
        this.listeners.getSignal(STRUCTURE_SIGNAL.initSFloorControl).remove(this.boundInitControl);
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.onKeyMouseConfirm.remove(this.onKeyMouseConfirm);
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);

        if (this.exitSimply) {
            let startEqualToEnd: boolean;
            if (this.helpLines.length <= 1) {
                startEqualToEnd = false;
            } else {
                //删除这条线的时候，同时需要清空它的临时图元
                let line = this.helpLines.pop();
                if (line && line.viewObj && line.viewObj.parent) {
                    line.viewObj.parent.remove(line.viewObj);
                }
                startEqualToEnd = this.helpLines[0]._geo.start.equals(this.helpLines[this.helpLines.length - 1]._geo.end);
            };
            //如果长度小于等于1，直接不能让其布置
            if (this.helpLines.length <= 1) {
                this.couldGenerateWall = false;
            } else if (this.helpLines.length === 2 && startEqualToEnd) {//如果长度等于2，且第一条边的起点等于第二条边的中点，这种情况是不能闭合的，也不能让它布置
                this.couldGenerateWall = false;
            } else if (!startEqualToEnd) {//多边形不闭合，强行让其闭合
                this.closePolygon();
                this.couldGenerateWall = true;
                this.listeners.signals.onOpeCommandControlEnd.dispatch();
            }
            if (this.couldGenerateWall) {
                //filter去掉长度为0的病态直线
                let polygon = new Polygon(this.helpLines.map(linet => linet._geo).filter(linet => linet.delta().lengthSq() > 1e-6));
                let dir = this.context.workPlaneContext.currentWorkPlane?.ucs.axisZ.clone() ?
                    this.context.workPlaneContext.currentWorkPlane?.ucs.axisZ.clone() : new Vector3(0, 0, 1);;
                let extrudeSolidT = new SFloorT(polygon, dir, this.thickness);
                extrudeSolidT.move(dir, -this.thickness);  //让板默认顶面对齐
                extrudeSolidT.move(dir, this.ez);
                extrudeSolidT.layerUuid = this.layerUuid;
                extrudeSolidT.materialUuid = this.componentData.materialUuid;
                this.editor.history.execute(new AddPrimitivesCommand([extrudeSolidT]));
            } else {
                this.extraContext.stmodeContext.pushLog(`布置失败，底面不能构成面域。`);
            }

        } else {
            if (this.couldGenerateWall) {
                //filter去掉长度为0的病态直线
                let polygon = new Polygon(this.helpLines.map(linet => linet._geo).filter(linet => linet.delta().lengthSq() > 1e-6));
                let dir = this.context.workPlaneContext.currentWorkPlane?.ucs.axisZ.clone() ?
                    this.context.workPlaneContext.currentWorkPlane?.ucs.axisZ.clone() : new Vector3(0, 0, 1);;
                let extrudeSolidT = new SFloorT(polygon, dir, this.thickness);
                extrudeSolidT.move(dir, -this.thickness);  //让板默认顶面对齐
                extrudeSolidT.move(dir, this.ez);
                extrudeSolidT.layerUuid = this.layerUuid;
                extrudeSolidT.materialUuid = this.componentData.materialUuid;
                this.editor.history.execute(new AddPrimitivesCommand([extrudeSolidT]));
            } else {
                this.extraContext.stmodeContext.pushLog(`布置失败，底面不能构成面域。`);
            }
        }
        this.editor.selectControl.setEnabled(true);
        this.editor.clampControl.enabled = true;
        this.editor.clampControl.hidden = false;
        this.listeners.signals.noNeedCapture.dispatch();
        this.helpLines.forEach(line => {
            if (line && line.viewObj && line.viewObj.parent) {
                line.viewObj.parent.remove(line.viewObj);
            }
        });

        console.log('AddSFloorControl removed');
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    initControl(data: any): void {
        this.componentData = data;
        this.onAssembleSFloor(data);
    }

    onAssembleSFloor = (data: any) => {
        let initData = { ...data };

        this.ez = data.ez;
        this.thickness = data.thickness ? data.thickness : 0;
        this.layerUuid = data.layerUuid;

        this.listeners.signals.setInitControlData.dispatch(initData);

        this.listeners.signals.needCapture.dispatch();
        this.editor.selectControl.setEnabled(false);
        this.listeners.signals.sendToDymodeTip.dispatch('指定起点:');
        this.extraContext.stmodeContext.setStmode('指定起点:', this.options[this.step] || []);
        this.step = 1;
        this.editor.renderer.domElement.focus();
        this.listeners.signals.onCursorChange.dispatch(CURSOR_TYPE.CROSS);
    }


    private _foot: Vector3 = new Vector3();
    onPointerMove = (event) => {
        let rect = this.editor.renderer.domElement.getBoundingClientRect();
        let x = (event.clientX - rect.x) / rect.width * 2 - 1;
        let y = -(event.clientY - rect.y) / rect.height * 2 + 1;
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        } else {
            this.context.ucsContext.unprojectCursorPoint(x, y, this.editor.camera, this.point_move,
                this.context.workPlaneContext.currentWorkPlane?.ucs.workPlane);
        }
        if (this.context.ucsContext.getWcs()) {
            const newP = this.context.ucsContext.getWcs().workPlane.projectPoint(this.point_down, this._foot);
            this.point_down.copy(newP.clone());
        }

        if (this.helpLines.length > 0) {
            let line = this.helpLines[this.helpLines.length - 1];
            line._geo.end.copy(this.point_move);
            line.updateViewGeometry();
            this.editor.listeners.signals.needRender.dispatch();
        };
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT) {
            this.extraContext.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
        if (event.button !== MOUSE.LEFT) return;
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        } else {
            this.point_down.set(this.extraContext.mousePosContext.x,
                this.extraContext.mousePosContext.y,
                this.extraContext.mousePosContext.z);
        }
        if (this.context.ucsContext.getWcs()) {
            const newP = this.context.ucsContext.getWcs().workPlane.projectPoint(this.point_down, this._foot);
            this.point_down.copy(newP.clone());
        }
        if (this.step === 1) {
            this.firstStep();
        } else if (this.step === 2) {
            this.secondStep();
        }
    }

    pointProjection = (point, line1, line2) => {
        const start1 = line1.getPoints()[0];
        const end1 = line1.getPoints()[1];
        const start2 = line2.getPoints()[0];
        const end2 = line2.getPoints()[1];

        // 计算直线的方向向量
        const direction1 = end1.clone().sub(start1);
        const direction2 = end2.clone().sub(start2);

        const normal = direction1.cross(direction2).normalize();

        // 选取其中一个点作为平面上的点
        const vector: Vector3 = point.clone().sub(start1);
        const distance = vector.dot(normal);

        // 计算投影点
        const projection: Point = point.clone().sub(normal.clone().multiplyScalar(distance));
        return projection;
    }

    onDymodeChanged = (value: dymode) => {
        if (this.step === 2) {
            //闭合
            if (value.choose === 'C') {
                this.exitSimply = false;
                //如果长度小于等于1，直接不能让其布置
                if (this.helpLines.length <= 1) {
                    this.couldGenerateWall = false;
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                    return;
                }
                //如果长度等于2，且第一条边的起点等于第二条边的中点，这种情况是不能闭合的，也不能让它布置
                let startEqualToEnd = this.helpLines[0]._geo.start.equals(this.helpLines[this.helpLines.length - 1]._geo.end);
                if (this.helpLines.length === 2 || startEqualToEnd) {
                    this.couldGenerateWall = false;
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                    return;
                }
                //多边形不闭合，强行让其闭合
                if (!startEqualToEnd) {
                    this.closePolygon();
                    this.couldGenerateWall = true;
                    this.listeners.signals.onOpeCommandControlEnd.dispatch();
                    return;
                }

            }
        }
    }

    //闭合底面
    closePolygon = () => {
        let start = this.helpLines[0]._geo.start.clone();
        this.helpLines[this.helpLines.length - 1]._geo.end.copy(start);
        this.helpLines.push(new LineT(start, start.clone()))
    }

    firstStep = () => {
        let newLine = new LineT(new Point().copy(this.point_down), new Point().copy(this.point_down));
        this.helpLines.push(newLine);
        this.extraContext.sceneContext.scene.add(newLine.render());
        this.editor.listeners.signals.needRender.dispatch();
        this.step = 2;
        this.listeners.signals.sendToDymodeTip.dispatch('指定下一点:');
        this.extraContext.dymodeContext.setMode(DYMODE_MODE.CHOOSE);
        this.extraContext.stmodeContext.setStmode('指定下一点:', this.options[this.step] || []);
    }

    secondStep = () => {
        if (this.helpLines.length > 0) {
            let line = this.helpLines[this.helpLines.length - 1];
            line._geo.end.copy(this.point_down);
            line.updateViewGeometry();
            let newLine = new LineT(new Point().copy(this.point_down), new Point().copy(this.point_down));
            this.helpLines.push(newLine);
            this.extraContext.sceneContext.scene.add(newLine.render());
            this.editor.listeners.signals.needRender.dispatch();
            this.listeners.signals.sendToDymodeTip.dispatch('指定下一点:');
            this.extraContext.stmodeContext.setStmode('指定下一点:', this.options[this.step] || []);
        };
    }

    onKeyMouseConfirm = () => {
        this.exitSimply = false;
        //如果长度小于等于1，直接不能让其布置
        if (this.helpLines.length <= 2) {
            this.couldGenerateWall = false;
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        //删除这条线的时候，同时需要清空它的临时图元
        let line = this.helpLines.pop();
        if (line && line.viewObj && line.viewObj.parent) {
            line.viewObj.parent.remove(line.viewObj);
        }
        //如果长度等于2，且第一条边的起点等于第二条边的中点，这种情况是不能闭合的，也不能让它布置
        let startEqualToEnd = this.helpLines[0]._geo.start.equals(this.helpLines[this.helpLines.length - 1]._geo.end);
        if (this.helpLines.length === 2 && startEqualToEnd) {
            this.couldGenerateWall = false;
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        //多边形不闭合，强行让其闭合
        if (!startEqualToEnd) {
            this.closePolygon();
            this.couldGenerateWall = true;
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        }
    }
}